import Select from 'react-select';

import { MultiOptionValue } from '@/core/interfaces/common';

interface FormMultipleSelectProps {
  backgroundcolor: string;
  error: () => string | false;
  isDisabled?: boolean;
  isRequired?: boolean;
  onMultiChange: (values: Array<MultiOptionValue>) => void;
  onFocus: () => void;
  name: string;
  options: Array<string>;
  values: Array<MultiOptionValue> | undefined;
}

export const FormMultipleSelect = ({
  backgroundcolor,
  error,
  isDisabled,
  isRequired,
  onMultiChange,
  onFocus,
  options,
  values = [],
  name,
}: FormMultipleSelectProps) => {
  const selectOptions = options.map(option => ({
    label: option,
    value: option,
  }));

  const placeholderText = isRequired ? `${name} *` : name;

  return (
    <Select
      isDisabled={isDisabled}
      isMulti
      name={name}
      placeholder={placeholderText}
      options={selectOptions}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          '&:hover': { borderColor: backgroundcolor },
          borderColor: state.isFocused ? backgroundcolor : 'rgba(24, 24, 24, 0.1)',
          ...(error() ? { borderColor: '#d53c2d' } : {}),
          boxShadow: 'none',
          fontSize: '16px',
          marginTop: '21px',
          padding: '10px 6px',
        }),
        indicatorSeparator: (baseStyles, state) => ({
          ...baseStyles,
          ...(state.hasValue ? {} : { display: 'none' }),
        }),
        placeholder: baseStyles => ({
          ...baseStyles,
        }),
      }}
      defaultValue={values}
      onChange={newOptions => onMultiChange([...newOptions])}
      onFocus={onFocus}
      className="custom-field-multi-select"
      classNamePrefix="select"
      required={isRequired}
    />
  );
};

FormMultipleSelect.defaultProps = {
  isDisabled: false,
  isRequired: false,
};
